import apiClient from "@/services/api-client";

export const automationService = {
  segments: async () => (await apiClient.get("/automation/segments")).data,
  previewSegment: async (rules: Record<string, unknown>, limit = 25) =>
    (await apiClient.post("/automation/segments/preview", { rules, limit }))
      .data,
  createSegment: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/automation/segments", payload)).data,
  updateSegment: async (id: string, payload: Record<string, unknown>) =>
    (await apiClient.patch(`/automation/segments/${id}`, payload)).data,
  refreshSegment: async (id: string) =>
    (await apiClient.post(`/automation/segments/${id}/refresh`)).data,
  playbooks: async () => (await apiClient.get("/automation/playbooks")).data,
  createPlaybook: async (payload: Record<string, unknown>) =>
    (await apiClient.post("/automation/playbooks", payload)).data,
  setPlaybookStatus: async (id: string, status: string, reason: string) =>
    (
      await apiClient.patch(`/automation/playbooks/${id}/status`, {
        status,
        reason,
      })
    ).data,
  launchPlaybook: async (id: string, payload: Record<string, unknown>) =>
    (await apiClient.post(`/automation/playbooks/${id}/launch`, payload)).data,
  runs: async (params?: { status?: string; tenantId?: string }) =>
    (await apiClient.get("/automation/runs", { params })).data,
  cancelRun: async (id: string, reason: string) =>
    (await apiClient.post(`/automation/runs/${id}/cancel`, { reason })).data,
  tasks: async (params?: { status?: string; assignedTo?: string }) =>
    (await apiClient.get("/automation/tasks", { params })).data,
  completeTask: async (
    id: string,
    note: string,
    outcome?: Record<string, unknown>,
  ) =>
    (
      await apiClient.post(`/automation/tasks/${id}/complete`, {
        note,
        outcome,
      })
    ).data,
};
